import { useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";

import OrganizationProfileContainer from "@/features/organizations/profile/components/OrganizationProfileContainer";
import { useLazyGetOrganizationByIdQuery } from "@/redux/service";
import BaseSpinner from "@/components_v2/Spiner/BaseSpinner";

const OrganizationProfile = () => {
  const { organizationId } = useParams();
  const [getOrganizationById, organizationResponse] =
    useLazyGetOrganizationByIdQuery();

  useEffect(() => {
    if (organizationId) {
      getOrganizationById(organizationId);
    }
  }, [organizationId]);

  if (organizationResponse.isLoading) return <BaseSpinner />;

  if (organizationResponse.isError) return <Navigate to="/signatories" />;

  return (
    organizationResponse.isSuccess && (
      <OrganizationProfileContainer organization={organizationResponse.data} />
    )
  );
};

export default OrganizationProfile;
